import { DoctorForUser } from 'api-client/contracts/doctor'

import { DoctorProfile } from '@/features/hospital/components/doctor-list/doctor-profile'
import { DoctorView } from '@/features/hospital/components/doctor-list/doctor-view'
import { cn } from '@/shared/utils'
import { generateTagId } from '@/utils/test-automation'

export { DoctorProfile, DoctorView }

interface Props {
  doctors: DoctorForUser[]
  defaultText?: {
    doctor?: string
    ceo?: string
    review?: string
  }
  isDoctorImpressionTrackerActive?: boolean
  onClickDoctorProfile?: (index: number) => void
  onDoctorImpressed?: (index: number) => void
}

const DoctorList = ({
  doctors,
  defaultText,
  isDoctorImpressionTrackerActive,
  onClickDoctorProfile,
  onDoctorImpressed,
}: Props) => {
  return (
    <div className={cn('flex flex-col gap-4')}>
      {doctors.map((doctor, index) => (
        <div
          key={`${doctor.doctorId}-${index}`}
          className="doctorViewWrapper"
          id={generateTagId('doctor', 'section', 'list', 'card', index.toString())}
        >
          <DoctorView
            doctor={doctor}
            defaultText={defaultText}
            isImpressionTrackerActive={isDoctorImpressionTrackerActive}
            onClickDoctorProfile={() => onClickDoctorProfile?.(index)}
            onImpressed={() => {
              onDoctorImpressed?.(index)
            }}
          />
        </div>
      ))}
    </div>
  )
}
export default DoctorList
